import { eEventBus, EventBus } from "../eventbus";

export const errorMessage = (error: any, notifyMessage: string | null = null): string => {
  let errorMessage = "";
  if (error.response) {
    error.response.data.errors.forEach((e) => {
      const message = e.message as string;
      errorMessage += message.replaceAll("\n", "<br />") + "<br />";
    });
  }
  if (error.errors && error.errors.length > 0) {
    error.errors.forEach((e) => {
      const message = e.message as string;
      errorMessage += message.replaceAll("\n", "<br />") + "<br />";
    });
  }
  EventBus.emit(eEventBus.BreakingDataError, {
    text: notifyMessage !== null ? notifyMessage : "",
    error: error
  });
  return errorMessage;
};

export const formatErrorMessage = (error: string): string => {
  return error.replace('"}', "") + "<br />";
};

export const insertLineBreakIfNotEmpty = (text: string): string => {
  return text === "" ? "" : "<br />";
};
